import React from "react";

const AnalysisIconSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 18 10"
    fill="none"
  >
    <path
      d="M1 9L5.48 4.69231L9.32 8.38462L17 1M17 1H11.24M17 1V6.53846"
      stroke="#757373"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default AnalysisIconSvg;
